// extracted by mini-css-extract-plugin
module.exports = {"avatarImg":"form_avatarImg_2H3Qv","clearButtonContainer":"form_clearButtonContainer_1ughv"};